export default __webpack_public_path__ + "static/media/issue-solver.e1995e76.png";